export const FDSStatus = {
    /* 결과 대기상태 */
    PENDING: 'PENDING',
    /* 성공 */
    FULFILLED: 'FULFILLED',
    /* 실패 */
    REJECTED: 'FAILED',
} as const

export type FDSStatusType = Constant<typeof FDSStatus>

/** FDS 인증 절차 실패 이유 */
export const FDSRejectionReason = {
    /** FDS 정보가 세팅되지 않은 상태 */
    FDS_INFO_REQUIRED: 'FDS_INFO_REQUIRED',
    /** 차단 유저 */
    BLOCK: 'BLOCK',
    /** 결제한도 초과 */
    SELF_BLOCK: 'SELF_BLOCK',
    /** FDS 인증창에서 인증 실패 */
    FDS_AUTHENTICATION_FAILED: 'FDS_AUTHENTICATION_FAILED',
    /** FDS 비번 재설정으로 인한 재시도 필요 */
    FDS_PASSWORD_CHANGED: 'FDS_PASSWORD_CHANGED',
    /** 인증 취소 */
    CANCEL: 'CANCEL',
} as const

export type FDSRejectionReasonType = Constant<typeof FDSRejectionReason>
